import { render, staticRenderFns } from "./RegisterTab.vue?vue&type=template&id=99ffa618"
import script from "./RegisterTab.vue?vue&type=script&lang=js"
export * from "./RegisterTab.vue?vue&type=script&lang=js"
import style0 from "./RegisterTab.vue?vue&type=style&index=0&id=99ffa618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports